export const getPreferredMapType = ({ contextMapType, hasOSMMaps = true, hasGoogleMaps = true } = {}) => {
  if (contextMapType) return contextMapType;
  let saved = null;
  try {
    saved = localStorage.getItem('preferred_map_type');
  } catch {
    saved = null;
  }
  if (saved) {
    if (saved === 'osm' && hasOSMMaps) return 'osm';
    if (saved !== 'osm' && hasGoogleMaps) return saved;
  }
  if (hasGoogleMaps) return 'roadmap';
  return 'osm';
};
